import { render, staticRenderFns } from "./NewbornCare.vue?vue&type=template&id=70f2b27f&"
import script from "./NewbornCare.vue?vue&type=script&lang=js&"
export * from "./NewbornCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports